import { call, put, select, takeEvery, takeLatest } from "redux-saga/effects"

import {
    GET_EMAIL_EVENTS,
    GET_EMAIL_TEMPLATE_BY_ID,
    CHECK_EMAIL_STATUS_BY_EVENT,
    DELETE_EMAIL_STATUS_BY_EVENT,

} from "./actionTypes"

import {
    getEmailEventsSuccess,
    getEmailEventsError,
    getEmailTemplateByIdSuccess,
    getEmailTemplateByIdError,
    checkEmailStatuByEventSuccess,
    checkEmailStatuByEventError,
    deleteEmailStatusByEventSuccess,
    deleteEmailStatusByEventError,

} from "./actions"

import {

    genericGetRequest_2, genericPostRequest,
} from "../../helpers/sf_backend_helper"
import { AppConfiguration } from "config"
import { bsh_getAdminUserDetails } from "helpers/sf_browser_storage_helper"
import { buildPaginationCacheKey } from "helpers/sf_utils"

const inFlightEmailEventRequests = new Set()

function* onGetEmailEvents(action) {
    try {
        const useCache = Boolean(action.payload?.useCache)
        const queryParams = action.payload?.queryParams || {}
        const requestedPageNumber = parseInt(queryParams.page_number, 10) || 1
        const cacheKey = useCache ? buildPaginationCacheKey(queryParams) : null
        const requestKey = `${cacheKey}:${requestedPageNumber}`
        const cachedPage = useCache
            ? yield select((state) => state.EmailEvents.page_cache?.[cacheKey]?.[requestedPageNumber])
            : null

        if (useCache && cachedPage) {
            return
        }

        if (useCache && inFlightEmailEventRequests.has(requestKey)) {
            return
        }

        if (useCache) {
            inFlightEmailEventRequests.add(requestKey)
        }

        let user = bsh_getAdminUserDetails();
        const response = yield call(
            genericGetRequest_2,
            `${AppConfiguration.BACKEND_URL}/api/v1/email_events`,
            queryParams,
            {
                Authorization: user.token,
            }
        )
        yield put(getEmailEventsSuccess(response, {
            appendResults: Boolean(action.payload?.appendResults),
            queryParams,
            useCache,
        }))
    } catch (error) {
        yield put(getEmailEventsError(error))
    } finally {
        if (action.payload?.useCache) {
            const queryParams = action.payload?.queryParams || {}
            const requestedPageNumber = parseInt(queryParams.page_number, 10) || 1
            const cacheKey = buildPaginationCacheKey(queryParams)
            inFlightEmailEventRequests.delete(`${cacheKey}:${requestedPageNumber}`)
        }
    }
}

function* onGetEmailTemplates(action) {
    try {
        let user = bsh_getAdminUserDetails();
        const response = yield call(
            genericGetRequest_2,
            `${AppConfiguration.BACKEND_URL}/api/v1/email_template_logs/${action.payload.template_id}`,
            action.payload?.queryParams,
            {
                Authorization: user.token,
            }
        )
        yield put(getEmailTemplateByIdSuccess(response))
    } catch (error) {
        yield put(getEmailTemplateByIdError(error))
    }
}

function* onCheckEmailEventById(action) {
    try {
        let auth_user = bsh_getAdminUserDetails();
        const URL = `${AppConfiguration.BACKEND_URL}/api/v1/email_status_checks`;
        const payload = {
            body: JSON.stringify({ ...action.payload }),
            headers: {
                Authorization: auth_user.token,
                'account-id': auth_user.account_id,
                'Content-Type': 'application/json',
            },
        }
        const response = yield call(genericPostRequest, URL, payload)
        yield put(checkEmailStatuByEventSuccess(response))
    } catch (error) {
        yield put(checkEmailStatuByEventError(error))
    }
}

function* onDeleteEmailEventById(action) {
    try {
        let auth_user = bsh_getAdminUserDetails();
        const URL = `${AppConfiguration.BACKEND_URL}/api/v1/email_delete_from_suppression_list`;
        const payload = {
            body: JSON.stringify({ ...action.payload }),
            headers: {
                Authorization: auth_user.token,
                'account-id': auth_user.account_id,
                'Content-Type': 'application/json',
            },
        }
        const response = yield call(genericPostRequest, URL, payload)
        yield put(deleteEmailStatusByEventSuccess(response))
    } catch (error) {
        yield put(deleteEmailStatusByEventError(error))
    }
}

function* EmailEventsSaga() {
    yield takeLatest(GET_EMAIL_EVENTS, onGetEmailEvents)
    yield takeEvery(GET_EMAIL_TEMPLATE_BY_ID, onGetEmailTemplates)
    yield takeEvery(CHECK_EMAIL_STATUS_BY_EVENT, onCheckEmailEventById)
    yield takeEvery(DELETE_EMAIL_STATUS_BY_EVENT, onDeleteEmailEventById)
}

export default EmailEventsSaga
